import type { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import SEO from '~~/next-seo.config'

import { dehydrate, QueryClient } from 'react-query'
import { GetListings, GetNftCollections, GetNfts } from '../context'

import dynamic from 'next/dynamic'

import NavBar from '~~/src/components/Main/NavBar'
const Banner = dynamic(() => import('~~/src/components/Hero_comp/Banner'), { ssr: false }),
  CollectionList = dynamic(() => import("~~/src/components/Hero_comp/CollectionList"), { ssr: false }),
  Explore = dynamic(() => import("~~/src/components/Hero_comp/Explore"), { ssr: false }),
  Listed = dynamic(() => import('~~/src/components/Hero_comp/Listed'), { ssr: false }),
  Footer = dynamic(() => import("~~/src/components/Main/Footer"), { ssr: false });

import ThreeScene from '../components/Hero_comp/ThreeScene'

export const heroindexStyle = {
  wrapper: `grid grid-cols-1 z-50`,
  container: `absolute z-10 w-[100%] grid place-content-center`,
}

// 
export const indexStyle = {
  wrapper: `dark:bg-slate-800 flex flex-col sm:w-[100hw]`,
  header: `pl-16 pt-10 pb-4 font-sans text-lg sm:text-xl md:text-2xl font-bold text-[#171717] dark:text-white`,
}

export async function getServerSideProps({ params }: any) {
  const serverQueryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  });

  try {
    await serverQueryClient.prefetchQuery('collections', () => GetNftCollections({ ChainId: "1", start: 0, limit: 5 }))
    await serverQueryClient.prefetchQuery('nfts', () => GetNfts({ start: 0, limit: 20 }))
    await serverQueryClient.prefetchQuery('listings', () => GetListings())
  } catch (error: any) {
    // ✅ Server survives! Log the error, but don't crash.
    console.error("SSR Fetch Failed:", error.message);
  }
  return {
    props: {
      dehydratedState: dehydrate(serverQueryClient)
    }
  }
}

const Home: NextPage = () => {

  return (
    <div>
      <NextSeo
        title={`Deepcity.io: Empowering Creators and Enthusiasts in the Decentralized Digital Asset Marketplace`}
        description={`Discover Deepcity.io, the leading decentralized marketplace for digital assets. Connect with creators and consumers and unlock a world of possibilities in digital asset trading. Join our vibrant community and explore the diverse range of Digital assets available for buying, selling, and interacting in a secure and transparent environment.`}
        canonical={`https://deepcity.io`}
        {...SEO}
      />
      <NavBar />
      <div className={heroindexStyle.container}>
        <Banner />
        <main className={heroindexStyle.wrapper}>
          <CollectionList />
          <Explore />
          <Listed />
        </main>
        <div className={`z-50`}>
          <Footer />
        </div>
        <ThreeScene />
      </div>
    </div>
  )
}

export default Home